import ChainlinkIcon from '@assets/icons/chainlink.svg';

export const EmptyIcon = () => (
  <img loading="lazy" src={ChainlinkIcon} className="size-5" alt="empty icon" />
);
